import { AxiosRequestConfig, AxiosResponse } from "axios";
import { IEntity } from "../domain/entity";
import { CachedRepository } from "./CachedRepository";
import { AuthenticatedHttpClient } from "./AuthenticatedHttpClient";
import { IPrefetchable, instanceOfIPrefetchable } from "../utilities";
import { LoggerFactory } from "../utilities/logger";

export class AuthenticatedCachedRepository<TId, TEntity extends IEntity<TId>> extends CachedRepository<TId, TEntity> implements IPrefetchable {
  constructor(private readonly _client: AuthenticatedHttpClient, createCache: (client: AuthenticatedHttpClient) => Promise<TEntity[]>, areEqual: (s: TId, d: TId) => boolean = (s, d) => s === d) {
    super(() => createCache(this._client), areEqual);
  }

  get shouldPrefetch(): boolean {
    return this._client.shouldPrefetch;
  }

  set shouldPrefetch(value: boolean) {
    this._client.shouldPrefetch = value;
  }

  protected applyPrefetchNecessity(...instances: any[]): void {
    for (const i in instances) {
      if (instanceOfIPrefetchable(instances[i])) {
        instances[i].shouldPrefetch = this.shouldPrefetch;
      } else if (this.shouldPrefetch) {
        this._privateLogger.warn("IPrefetcheableを実装してないのでプリフェッチできません.通常のフェッチを実行します.[" + i + "]" + instances[i].toString());
      }
    }
  }

  protected async fetch<TClient, TResult = any>(client: TClient, fetch: (c: TClient) => Promise<TResult>): Promise<TResult> {
    this.applyPrefetchNecessity(client);
    return fetch(client);
  }

  protected get token(): string {
    return this._client.token;
  }

  protected async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.get(
      url,
      config,
    );
  }

  protected async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.post(
      url,
      data,
      config,
    );
  }

  private readonly _privateLogger = LoggerFactory.getLogger();
}
